import * as React from 'react';
import { Messaging } from './types';

export const FmcContext = React.createContext<Messaging>({} as any);
